import { Component, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';


import { DrawerState } from 'ion-bottom-drawer';

@Component({
  selector: 'app-deals',
  templateUrl: './deals.page.html',
  styleUrls: ['./deals.page.scss'],
})
export class DealsPage implements OnInit {
  shouldBounce = true;
  disableDrag = false;
  dockedHeight = 480;
  distanceTop = 150;
  transition: '0.25s ease-in-out';
  drawerState = DrawerState.Docked;
  states = DrawerState;
  minimumHeight = 0;

  isloggedIn = false;
  constructor( private platform: Platform) {
    this.getData();
  }

  ngOnInit() {
   
  }
  getData() {
    let login = localStorage.getItem('isLogin');
      if (login =='true') {
        this.isloggedIn = true;
      }
 
  }
}
